module.exports = function(menus) {
	"use strict";
  menus
  .controller('menusController', menusController)
	menusController.$inject = ["$state","$stateParams","authtokenService","$window","config","API_URL","Slug","$timeout","$http","$scope","$rootScope","NgTableParams", "getDataService", "jQuery","refreshtokenService","reqursiveService","deleteDataService","alertService", "putDataService","postDataService","cleanObj","serverError","offlineError"];
  function menusController($state,$stateParams,authtokenService,$window,config,API_URL,Slug,$timeout,$http,$scope,$rootScope,NgTableParams,getDataService,jQuery,refreshtokenService,reqursiveService,deleteDataService,alertService,putDataService,postDataService,cleanObj,serverError,offlineError) {
    var vmm = this;
    var token = authtokenService.getToken();
    Dropzone.autoDiscover = false;
    vmm.dropzone = {};
    vmm.selectedMenuAction = {value:'create-new'};
    vmm.linkUrl = "";
    vmm.navigationId;
    vmm.openItem = {};
    vmm.copyNode = {};
    vmm.navigationOptions = {};
    vmm.menuOptions = [];
    if($rootScope.role_id == 'superadmin') {
      vmm.superAdminPermisions = true;
    }
    vmm.isNumberKey = function(evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
    }
    // vmm.treeOptions = {
    //   dropped: function(event) {
    //     if(event.dest.nodesScope.depth()==0) {
    //       event.source.nodeScope.$modelValue.topLevel = true;
    //     } else {
    //       event.source.nodeScope.$modelValue.topLevel = false;
    //       delete event.source.nodeScope.$modelValue.color
    //     }
    //   }
    // }
    function addEmptyArrayFunction() {
      var addEmptyArry = function(arry) {
        for (var i=0; i<arry.length; i++) {
          arry[i]._id = Math.random().toString(36).substring(2, 32);
          if(arry[i].children) {
            addEmptyArry(arry[i].children)
          } else {
            arry[i].children = [];
          }
        }
      }
      addEmptyArry(vmm.navigationValue)
    }
    function cleanEmptyArrayFunction() {
      var cleanEmptyArray = function(array) {
        for (var i=0; i<array.length; i++) {
          delete array[i]._id;
          if(array[i].children) {
            if(array[i].children.length == 0) {
              delete array[i]['children'];

            } else {
              cleanEmptyArray(array[i].children)
            }
          }
        }
        vmm.openItem = {}
      }
      cleanEmptyArray(vmm.navigationValue);
    }
    // vmm.previewMenu = function(node) {
    //   var previewObj =[]
    //   var uri = '';
    //   var getItemsWidthColor = function(array, children, parent) {
    //     for (var i=0; i<array.length; i++) {
    //       if(node && children && parent && parent.uri && node.objId == array[i].objId) {
    //         uri = parent.uri
    //       }
    //       if(array[i].color) {
    //         previewObj.push(
    //           {
    //             item : array[i].objId,
    //             type: array[i].type,
    //             fc : array[i].color.font,
    //             bc : array[i].color.background
    //           }
    //         )
    //       }
    //       if(array[i].children && array[i].children.length > 0) {
    //         getItemsWidthColor(array[i].children, 'children', array[i])
    //       }
    //     }
    //   }
    //   getItemsWidthColor(vmm.navigationValue)
    //   if(uri) {
    //     if(uri.charAt(0) == '/' && config.baseHref.charAt(config.baseHref.length -1) == '/') {
    //       uri = uri.slice(1,uri.length)
    //     } else if(uri.charAt(0) != '/' && config.baseHref.charAt(config.baseHref.length -1) != '/') {
    //       uri = '/' + uri
    //     } else {
    //       uri = uri
    //     }
    //   }
    //   $window.open(config.baseHref + uri + "?preview=true&data=" + encodeURIComponent(JSON.stringify(previewObj)), '_view');
    //   previewObj = null;
    // }
    $scope.$on('select-tag', function(event,data) {
      vmm.tagObj = data.selectedTagObj;
    });
    vmm.addNavigationItem = function(node_type) {
      function addNavigationItemFunction(nodeTitle, nodeUrl, nodeId) {
        var obj = {
          title:nodeTitle,
          type:node_type,
          url: nodeUrl,
          _id: Math.random().toString(36).substring(2, 32),
          objId: nodeId,
          children:[]
        }
        vmm.navigationValue.push(obj);
      }

      var validationItem = true;
      if(node_type == 'post_tag') {
        if(vmm.tag) {
          vmm.tagRequired = false
        } else {
          vmm.tagRequired = true;
          validationItem = false
        }
        if(validationItem) {
          addNavigationItemFunction(vmm.tagObj.tagName, vmm.tagObj.tagUrl, vmm.tagObj.tagId);
          vmm.tag = '';
        }
      }
      if (node_type == 'custom') {
        if(!vmm.linkUrl) {
          vmm.linkUrlRequired = true;
          validationItem = false;
        } else {
          vmm.linkUrlRequired = false;
        }
        if(vmm.linkText) {
          vmm.linkTextRequired = false;
        } else {
          vmm.linkTextRequired = true;
          validationItem = false;
        }
        if(validationItem) {
          addNavigationItemFunction(vmm.linkText, vmm.linkUrl, Slug.slugify(vmm.linkText));
          vmm.linkUrl = '';
          vmm.linkText = null;
        }
      }
      if(node_type == 'post') {
        if(vmm.searchPostObj) {
          vmm.singlePostRequired = false
        } else {
          vmm.singlePostRequired = true
          validationItem = false;
        }
        if(vmm.singlePostLabel) {
          vmm.singlePostLabelRequired = false
        } else {
          vmm.singlePostLabelRequired = true
          validationItem = false;
        }
        if(validationItem) {
          addNavigationItemFunction(vmm.singlePostLabel, vmm.searchPostObj.url,vmm.searchPostObj.id)
          vmm.searchPostReset()
          vmm.singlePostLabel = '';
        }
      }
    }
    function transitionTo(id) {
      $state.transitionTo('app.menus', {id: id}, {
        location: true,
        inherit: true,
        relative: $state.$current,
        notify: false
      });
    }
    function createNewMenu() {
      vmm.newMenu = true;
      vmm.navigationValue = [];
      vmm.navigationOptions = {};
      vmm.selectedMenuType = {value:'desk'};
      vmm.selectedMenuAction.value = 'create-new';
      vmm.createMenuName = '';
      vmm.createMenuVer = '';
      vmm.menuExist = false;
      vmm.menuNameRequired = false;
      vmm.menuVersionRequired = false;
    }
    vmm.createNewMenu = function() {
      createNewMenu()
      transitionTo(vmm.selectedMenuAction.value)
    }
    vmm.changeNavigationsOptions = function(navigationId) {
      vmm.openItem = {};
      vmm.copyNode = {};
      if(navigationId == 'create-new') {
        createNewMenu()
      } else {
        vmm.newMenu = false;
        vmm.navigationId = navigationId;
        getNavigationFunction();
      }
      transitionTo(navigationId)
    }
    vmm.toggleNavigationItemChildren = function(element) {
      element.toggle();
    }
    vmm.removeItem = function(element) {
      element.remove();
    }
    function initalizedDropzone(node, type) {
      if(!vmm.dropzone[node._id]) {
        vmm.dropzone[node._id] = {
        }
      }
      vmm.dropzone[node._id][type]={
        dzOptions : {
          url :API_URL+'upload/navigation',
          paramName : 'photo',
          maxFilesize : '500',
          parallelUploads: 1,
          acceptedFiles : '.svg, image/png',
          addRemoveLinks : true,
          autoProcessQueue : false,
          dictInvalidFileType: 'This file type is not supported.',
          dictFileTooBig:'File size too Big',
          headers:{
            'x-auth': token  
          }
        },
        dzCallbacks : {
          'addedfile' : function(file){
            node[type] = null
            if(vmm.dropzone[node._id][type].file) {
              vmm.dropzone[node._id][type].dzMethods.removeFile(vmm.dropzone[node._id][type].file);
            }
            vmm.dropzone[node._id][type].file = file;
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                token = authtokenService.getToken();
                vmm.dropzone[node._id][type].dzOptions.headers['x-auth'] = token;
                vmm.dropzone[node._id][type].dzMethods.processQueue();
              },
              function(error) {
                // report something
              },
              function(progress) {
                // report progress
            });
          },
          'success' : function(file, xhr, response){
            file.previewElement.classList.remove("dz-error");
            var data = JSON.parse(response.currentTarget.response);
            if(data && data.url) {
              $timeout(function() {
                node[type] = {
                  url:data.url,
                  width: data.width,
                  height: data.height
                }
                vmm.dropzone[node._id][type].dzMethods.removeFile(vmm.dropzone[node._id][type].file);
                vmm.dropzone[node._id][type].file = null;
              },1000) 
            }
          },
          'error' : function(file,message) {
            if(message && message.error && message.error.message) {
              jQuery(file.previewElement).find('.dz-error-message').text(message.error.message);
            }
          },
          'sending':function(file, xhr, formData) {
          },
          'complete':function(file) {
            if(file.xhr && file.xhr.status == 401) {
                file.previewElement.classList.remove("dz-error");
                var promise = refreshtokenService.getAccessToken();
                promise.then(
                    function(answer) {
                    if(answer==200) {   
                      var token = authtokenService.getToken();
                      vmm.dropzone[node._id][type].dzOptions.headers['x-auth'] = token;
                      vmm.dropzone[node._id][type].dzMethods.uploadFile(file)
                    }
                    },
                    function(error) {
                    },
                    function(progress) {
                    // report progress
                });
            }
          }
        },
        dzMethods : {
        }
      }
    }
    function destroyDropzone(nodeId,type) {
      if(type) {
        vmm.dropzone[nodeId][type] = null
      } else {
        vmm.dropzone[nodeId] = null
      }
    }
    vmm.navigationOptionsChange = function(bool,type) {
      if(bool) {
        for(var key in vmm.openItem) {
          if(!vmm.dropzone[key] || !vmm.dropzone[key][type]) {
            initalizedDropzone(vmm.openItem[key], type)
          }
        }
      } else {
        for(var key in vmm.openItem) {
          if(vmm.dropzone[key] && vmm.dropzone[key][type]) {
            destroyDropzone(key,type)
            delete vmm.copyNode[key][type]
          }
        }
        var deleteTypeProp = function(array) {
          for (var i=0; i<array.length; i++) {
            delete array[i][type];
            if(array[i].children) {
              deleteTypeProp(array[i].children)
            }
          }
        }
        deleteTypeProp(vmm.navigationValue);
      }
    }
    vmm.toggleNavigationItem = function(node) {
      vmm.copyNode[node._id] = angular.copy(node);
      if(vmm.openItem[node._id]) {
        vmm.openItem[node._id] = false
      } else {
        vmm.openItem[node._id] = node
      }
      if(vmm.openItem[node._id]) {
        if(vmm.navigationOptions.image) {
          initalizedDropzone(node, 'image')
        }
        if(vmm.navigationOptions.hamburger_image) {
          initalizedDropzone(node, 'hamburger_image')
        }
      } else {
        destroyDropzone(node._id)
      }
    }
    vmm.cancelEditItem = function(node) {
      vmm.openItem[node._id] = false;
      if(vmm.dropzone[node._id]) {
        destroyDropzone(node._id)
      }
      function mergeObjects(obj1, obj2) {
        for (var key in obj1) {
            if (!obj2.hasOwnProperty(key)) {
                delete obj1[key];
            }
        }
        for (var key in obj2) {
            if(key != 'children') {
              obj1[key] = obj2[key];
            }
        }
      }
      //mutate node obj
      mergeObjects(node, vmm.copyNode[node._id]);
    }
    vmm.removeColor = function(node, type) {
      delete node.color[type];
      if (Object.keys(node.color).length === 0 && node.color.constructor === Object) {
        delete node.color;
      }
    }
    vmm.addColor = function(node, type) {
      if(node.color) {
        node.color[type] = "#ffffff";
      } else {
        node.color = {};
        node.color[type] = "#ffffff";
      }
    }
    vmm.removeImage = function(node, type) {
      delete node[type];
    }
    var saveOrUpdateMenuFunction = function(state) {
      var postFunction = function() {
        postDataService.save({
          param1:'options', 
          param2: 'navigation', 
          param3:'save'
        },{
          menu_id: vmm.navigationId,
          value: vmm.navigationValue,
          options: (state=='create')? vmm.navigationOptions:undefined
        }).$promise.then(function(data){
            $rootScope.hasLoaded = true;
            alertService('success','Success ', data.message, 2000);
            addEmptyArrayFunction();
            if(state=='create') {
              vmm.newMenu = false;
              vmm.menuOptions.push(vmm.navigationId);
              vmm.selectedMenuAction.value = vmm.navigationId;
              transitionTo(vmm.navigationId)
            }
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status == 401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
            function(answer) {
              if(answer==200) {
                postFunction();
              }
              // do something
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
            });
          }else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        });
      }
      postFunction();
    }
    vmm.saveMenu = function(state) {
      var validationSave = true;
      var saveMenuFuncton = function(state) {
        $rootScope.hasLoaded = false;
        cleanEmptyArrayFunction();
        saveOrUpdateMenuFunction(state);
      }
      if(state == 'create') {
        var slug = Slug.slugify(vmm.createMenuName);
        vmm.navigationId = vmm.selectedMenuType.value + '_' + slug + '_' + vmm.createMenuVer;
        if(!vmm.menuOptions.includes(vmm.navigationId)) {
          vmm.menuExist = false;
        } else {
          validationSave = false;
          vmm.menuExist = true;
        }
        if(vmm.createMenuName) {
          vmm.menuNameRequired = false;
        }else {
          validationSave = false;
          vmm.menuNameRequired = true;
        }
        if(vmm.createMenuVer) {
          vmm.menuVersionRequired = false;
        }else {
          validationSave = false;
          vmm.menuVersionRequired = true;
        }
        if(validationSave) {
          saveMenuFuncton(state);
          vmm.createMenuName='';
          vmm.createMenuVer='';
        }
      } else {
        saveMenuFuncton();
      }
      
    }
    vmm.deleteMenu = function() {
      $rootScope.hasLoaded = false;
      var deleteFunction = function() { 
        deleteDataService.remove({
          param1:'options',
          param2:'navigation',
          param3:vmm.navigationId
        }).$promise.then(function(data){
            $rootScope.hasLoaded = true;
            alertService('success','Success ', data.message, 2000);
            vmm.menuOptions.splice(vmm.menuOptions.indexOf(vmm.navigationId),1);
            $timeout(function() {
              vmm.createNewMenu()
            },0)
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', 'Please check your internet connection and try again.');
            return
          }
          if(error.status == 401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
            function(answer) {
              if(answer==200) {
                deleteFunction();
              }
              // do something
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
            });
          }else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        });
      }
      deleteFunction();
    }
    var getNavigationFunction = function() {
      $rootScope.hasLoaded = false;
      getDataService.get({param1:'options', param2: 'navigation',param3:vmm.navigationId}).$promise.then(function(data){
        if(data.navigation.length>0) {
          if(data.navigation[0].options) {
            vmm.navigationOptions = data.navigation[0].options
          } else {
            vmm.navigationOptions = {}
          }
          if(data.navigation[0].value) {
            vmm.navigationValue = data.navigation[0].value;
            addEmptyArrayFunction();
          }
        }
        $rootScope.hasLoaded = true;
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          return
        }
        if(error.status == 401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
          function(answer) {
            if(answer==200) {
              getNavigationFunction();
            }
            // do something
          },
          function(error) {
            // report something
            $rootScope.hasLoaded = true;
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.')
          },
          function(progress) {
           // report progress
          });
        }else if(error.status ==502) {
            serverError();
        } else {
          $rootScope.hasLoaded = true;
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.')
        }
      });
    };
    var getCategoryAndPages = function() {
      var getCategoriesFunction= function() {   
        getDataService.get({param1:'categories', param2: null, tree:1}).$promise.then(function(data){
          vmm.categories = data.categories;
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            return
          }
          if(error.status == 401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
            function(answer) {
              if(answer==200) {
                getCategoriesFunction();
              }
             
              // do something
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
            });
          }else if(error.status ==502) {
            serverError();
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.')
          }
        });
      }
      var getPagesFunction = function() {
        getDataService.get({param1:'pages', param2: 'list'}).$promise.then(function(data){
          vmm.pages = data.pages;
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            return
          }
          if(error.status == 401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
            function(answer) {
              if(answer==200) {
                getPagesFunction();
              }
              // do something
            },
            function(error) {
              // report something
            },
            function(progress) {
             // report progress
            });
          }else if(error.status ==502) {
            serverError();
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.')
          }
        });
      }
      getPagesFunction();
      getCategoriesFunction();
    }
    var getNavigationsOptionsFunction = function() {
      getDataService.get({param1:'options', param2: 'navigations'}).$promise.then(function(data){
        if(data.navigations.length>0) {
          vmm.menuOptions = data.navigations;
          var current;
          if($stateParams.id) {
            for(var i = 0; i<vmm.menuOptions.length;i++) {
              if($stateParams.id == vmm.menuOptions[i]) {
                vmm.navigationId = vmm.menuOptions[i];
                vmm.selectedMenuAction.value = vmm.menuOptions[i];
                current = true
                break
              }
            }
            if($stateParams.id == 'create-new') {
              vmm.selectedMenuAction.value = 'create-new'
              current = true;
              createNewMenu()
            }
          }
          if(!current) {
            vmm.navigationId = vmm.menuOptions[0];
            vmm.selectedMenuAction.value = vmm.menuOptions[0];
            transitionTo(vmm.menuOptions[0])
          }
        } else {
          vmm.createNewMenu()
        }
        if(vmm.navigationId) {
          getNavigationFunction(); 
        }
        getCategoryAndPages();
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          return
        }
        if(error.status == 401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
          function(answer) {
            if(answer==200) {
              getNavigationsOptionsFunction();
            }
            // do something
          },
          function(error) {
            // report something
          },
          function(progress) {
           // report progress
          });
        }else if(error.status ==502) {
          serverError();
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.')
        }
      });
    };
    getNavigationsOptionsFunction();
    if(!window.navigator.onLine) {
      offlineError('refresh')
      return
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/menusModule/menus/js/menusController.js
// module id = 529
// module chunks = 0